import React, { useEffect } from "react";
import "./home.css";
import Youtube from "../../youtube/Youtube";
import { Helmet } from "react-helmet";

function Home(props) {
  const pageTitle = "JXSRMA | " + props.title;
  const pageDescription = "Welcome to JXSRMA Official Website.";
  const pageImage = "https://i.ibb.co/PFx9Bds/Glass.jpg";
  const pageUrl = "https://jxsrma.web.app/";
  const siteName = "JXSRMA Official Website";

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
<Helmet>
        <title>{pageTitle}</title>
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={pageImage} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={siteName} />
      </Helmet>
      <div className="home-main" id="home">
        {/* <div className="home-image-container"> */}
        <img src="https://i.ibb.co/PFx9Bds/Glass.jpg" alt="" />
        <h1>Welcome</h1>
        <p>to the unknown music library</p>
        <iframe
          style={{ borderRadius: "12px" }}
          src="https://open.spotify.com/embed/artist/76RdxImQYMELfBJ99W7QsE?utm_source=generator&theme=0"
          title="Spotify"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
          frameBorder={0}
          w
        ></iframe>
        <div className="home-social">
          <a
            href="https://instagram.com/jxsrma"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-instagram fa-2xl"></i>
          </a>
          <a
            href="https://www.youtube.com/@jxsrma"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-youtube fa-2xl"></i>
          </a>
          <a
            href="https://twitter.com/jxsrma"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-x-twitter fa-2xl"></i>
          </a>
          <a
            href="https://www.twitch.tv/jxsrma"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-twitch fa-2xl"></i>
          </a>
        </div>
      </div>
      <Youtube />
    </>
  );
}

export default Home;
